const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
const ps = import.meta.env.VITE_POWERSYNC_URL as string | undefined;

export const env = {
  supabaseUrl: url ?? '',
  supabaseAnonKey: anon ?? '',
  powersyncUrl: ps ?? '',
  /** true when all three are configured; otherwise the app runs in local demo mode */
  cloud: Boolean(url && anon && ps),
  version: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.1.0-dev',
};
